import React, {useState} from 'react'
import {Alert, Portal, Snackbar} from '@mui/material'
import {useCloudFunctionsService} from '../backend/CloudFunctionsServiceContext'
import {googleLogin} from './authDuck'
import {useAppDispatch} from '../store/hooks'
import Button from '@mui/material/Button'
import {useApplicationServices} from '../backend/ApplicationServicesContext'
import NavItem from '../NavItem'
import {useNavigate} from 'react-router-dom'

function SignInNavItem() {
  const {authService} = useApplicationServices()
  const service = useCloudFunctionsService()
  const dispatch = useAppDispatch()
  return <NavItem onClick={() => dispatch(() => googleLogin(authService, service))} text={'Sign In'}/>
}

function SignInButton() {
  const {authService} = useApplicationServices()
  const service = useCloudFunctionsService()
  const dispatch = useAppDispatch()
  return (
    <Button color="inherit" onClick={() => dispatch(() => googleLogin(authService, service))}>
      Sign In
    </Button>
  )
}

function SignOutAction({navigation = false}: {navigation?: boolean}) {
  const {authService} = useApplicationServices()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pending, setPending] = useState(false)
  const [error, setError] = useState(false)
  const signOut = async () => {
    setPending(true)
    setError(false)
    try {
      await dispatch(() => authService.signOut())
      await navigate('/')
    } catch {
      setError(true)
    } finally {
      setPending(false)
    }
  }
  return <>
    {navigation ? <NavItem onClick={signOut} text="Sign Out" disabled={pending}/> :
      <Button color="inherit" onClick={signOut} disabled={pending}>Sign Out</Button>}
    <Portal><Snackbar open={error} onClose={() => setError(false)}>
      <Alert severity="error" onClose={() => setError(false)}>Unable to sign out. Please try again.</Alert>
    </Snackbar></Portal>
  </>
}

function SignOutNavItem() {
  return <SignOutAction navigation/>
}

function SignOutButton() {
  return <SignOutAction/>
}

export {SignInNavItem, SignInButton, SignOutButton, SignOutNavItem}

